import { useMemo } from 'react';

export const useBrandNames = (categoryItems: Product[]) => {
  return useMemo(() => {
    return Array.from(
      new Set(
        categoryItems
          .map((item) => item.brand_name)
          .filter((brand) => brand && brand.trim() !== '')
      )
    );
  }, [categoryItems]);
};
